import Debts from "./Debts";

export default Debts;